/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandResponse,
    BrandResponseFromJSON,
    BrandResponseFromJSONTyped,
    BrandResponseToJSON,
    MarketResponse,
    MarketResponseFromJSON,
    MarketResponseFromJSONTyped,
    MarketResponseToJSON,
    ReadWritePermissionTypeResponse,
    ReadWritePermissionTypeResponseFromJSON,
    ReadWritePermissionTypeResponseFromJSONTyped,
    ReadWritePermissionTypeResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface BrandAndMarketPermissionResponse
 */
export interface BrandAndMarketPermissionResponse {
    /**
     * 
     * @type {BrandResponse}
     * @memberof BrandAndMarketPermissionResponse
     */
    brand?: BrandResponse;
    /**
     * 
     * @type {MarketResponse}
     * @memberof BrandAndMarketPermissionResponse
     */
    market?: MarketResponse;
    /**
     * 
     * @type {ReadWritePermissionTypeResponse}
     * @memberof BrandAndMarketPermissionResponse
     */
    permission?: ReadWritePermissionTypeResponse;
}

export function BrandAndMarketPermissionResponseFromJSON(json: any): BrandAndMarketPermissionResponse {
    return BrandAndMarketPermissionResponseFromJSONTyped(json, false);
}

export function BrandAndMarketPermissionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrandAndMarketPermissionResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brand': !exists(json, 'brand') ? undefined : BrandResponseFromJSON(json['brand']),
        'market': !exists(json, 'market') ? undefined : MarketResponseFromJSON(json['market']),
        'permission': !exists(json, 'permission') ? undefined : ReadWritePermissionTypeResponseFromJSON(json['permission']),
    };
}

export function BrandAndMarketPermissionResponseToJSON(value?: BrandAndMarketPermissionResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brand': BrandResponseToJSON(value.brand),
        'market': MarketResponseToJSON(value.market),
        'permission': ReadWritePermissionTypeResponseToJSON(value.permission),
    };
}


